import {get} from 'lodash/fp';

import {Rank} from '/constant/TestIDs';
import {
  INTEGRATED_EXECUTIVE_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {showComingSoonToast} from '/util/toast.util';

import PeopleData from '../../PeopleData';
import PeopleExtendedData from '../../PeopleExtendedData';
import {PersonStats} from '../personStats';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.seniorCoachTeams.${key}`, value);

export default {
  dataComponent: PeopleData,
  dataComponentProps: {
    getPeople: get('coaches'),
    getTitle: (target: any) => {
      return target <= 1
        ? tt('title.incomplete.singular', 'Senior Coach Team')
        : tt('title.incomplete.plural', 'Senior Coach Teams');
    },
    personIsCoach: true,
  },
  extendedDataComponent: PeopleExtendedData,
  extendedDataComponentProps: {
    getPeople: get('coaches'),
    personIsCoach: true,
    getVacantName: () => tt('vacancyPosition', 'Senior Coach'),
    getVacancyCta: () => tt('vacancyCta', 'See Who’s Close To SC'),
    getPersonDescription: () => tt('position', 'Senior Coach'),
    getPersonStats: (data: any) =>
      PersonStats(
        {
          subheaderFirst: tt('orderingEntities', 'Ordering Entities'),
          subheaderSecond: tt('gqv', 'GQV'),
          count: data.orderingEntitiesCount,
          target: data.orderingEntitiesTarget,
        },
        data,
      ),
    onVacancyCtaPress: () =>
      showComingSoonToast('rank progress close to sc rank'),
  },
  isComplete: ({currentCount: current, target}: any) => current >= target,
  hasExtendedDetail: true,
  presentedFor: [
    INTEGRATED_REGIONAL_DIRECTOR,
    INTEGRATED_NATIONAL_DIRECTOR,
    INTEGRATED_EXECUTIVE_DIRECTOR,
  ],
  testID: Rank.rankSeniorCoachTeams,
};
